<script>
import BaseSelect from '@/components/BaseSelect.vue';
import BaseSelectMulti from '@/components/BaseSelectMulti.vue';
import TaskViewInfoPopup from './view/TaskViewInfoPopup.vue';
import BaseTooltipDropdown from '../BaseTooltipDropdown.vue';

export default {
  name: 'ProjectFileFiltersContainer',
  components: { BaseSelect, BaseSelectMulti, TaskViewInfoPopup, BaseTooltipDropdown }, // eslint-disable-line
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    projects: {
      type: Array,
      default: () => [],
    },
    tasks: {
      type: Array,
      default: () => [],
    },
    isGroupedByProjects: Boolean,
    areAllProjectsCollapsed: Boolean,
  },
  data() {
    return {
      extraFiltersAreVisible: false,
    };
  },
  computed: {
    projectsOptions() { return this.projects.map((p) => ({ value: p['@id'], label: p.name })); },

    userOptions() {
      const nonUniqueWatchers = [];
      const nonUniqueAuthors = [];
      const nonUniqueManagers = [];

      this.tasks.forEach((t) => {
        if (t.manager) {
          nonUniqueManagers.push(this.createUserOption(t.manager));
        }

        nonUniqueWatchers.push(...t.members.map(m => this.createUserOption(m)));
        nonUniqueAuthors.push(this.createUserOption(t.author));
      });

      const authors = this.prepareUserOptions(nonUniqueAuthors);
      const managers = this.prepareUserOptions(nonUniqueManagers);
      const watchers = this.prepareUserOptions(nonUniqueWatchers);
      const members = this.prepareUserOptions([...authors, ...managers, ...watchers]);

      return { authors, managers, watchers, members }; // eslint-disable-line
    },

    statusesOptions() {
      return [...new Set(this.tasks.map((t) => t.getStatusName()))];
    },

    prioritiesOptions() {
      const nonUnique = this.tasks.map((p) => p.priority);

      return Object.values(nonUnique
        .reduce((acc, value) => ({ ...acc, [value]: value }), {}))
        .map((p) => ({ value: p, label: p }));
    },

    buttons() {
      return [
        // { name: 'parameters',                   active: this.extraFiltersAreVisible,      title: 'Все фильтры',               handler: () => this.extraFiltersAreVisible = !this.extraFiltersAreVisible,  }, // eslint-disable-line
        { name: 'expand2',                      active: this.areAllProjectsCollapsed,     title: 'Свернуть проекты',                     handler: () => this.$emit('toggleProjects'),                                }, // eslint-disable-line
        { name: 'question-circle-thin',         active: false,                            title: 'Справка',                              handler: () => this.$refs.info.open(),                                      }, // eslint-disable-line
        { name: 'task-view/hide-projects',      active: !this.isGroupedByProjects,        title: 'Группировать по проектам',             handler: () => this.$emit('toggleGroupingByProjects'),                      }, // eslint-disable-line
        { name: 'task-view/hide-closed-tasks',  active: this.filters.isClosed,            title: 'Скрыть закрытые задачи',               handler: () => this.$emit('toggleClosedTasks'),                             }, // eslint-disable-line
        { name: 'task-view/hide-noDate-tasks',  active: this.filters.isDateFinishOpen,    title: 'Скрыть задачи без даты завершения',    handler: () => this.$emit('toggleTasksWithoutDateFinish'),                  }, // eslint-disable-line
        { name: 'waiting',                      active: false,                            title: 'Обновить список задач',                handler: () => this.$emit('updateTasks'),                                   }, // eslint-disable-line
      ];
    },
  },
  methods: {
    changeFilters(value, field) { this.$emit('changeFilters', value, field); },

    createUserOption(user) {
      const userName = user.name ? `${user.name} ${user.surname}` : user.email;
      return { value: user['@id'], label: userName };
    },

    prepareUserOptions(users) {
      return Object.values(users.reduce((acc, value) => ({ ...acc, [value.value]: value }), {})).sort((a, b) => a.label.localeCompare(b.label));
    },
  },
};
</script>

<template lang="pug">
.b-task-filters-container
  TaskViewInfoPopup(ref="info")
  ._main-filters
    BaseSelectMulti.users.select(:value="filters.projects" @input="changeFilters($event, 'projects')" :options="projectsOptions" label="Проект")
    BaseSelectMulti.users.select(:value="filters.authors" @input="changeFilters($event, 'authors')" :options="userOptions.authors" label="Автор")
    BaseSelectMulti.users.select(:value="filters.managers" @input="changeFilters($event, 'managers')" :options="userOptions.managers" label="Ответственный")
    BaseSelectMulti.users.select(:value="filters.statuses" @input="changeFilters($event, 'statuses')" :options="statusesOptions" label="Статус")
    BaseSelectMulti.users.select(:value="filters.priorities" @input="changeFilters($event, 'priorities')" :options="prioritiesOptions" label="Приоритет")
    BaseSelectMulti.users.select(:value="filters.users" @input="changeFilters($event, 'users')" :options="userOptions.members" label="Участвует" useFilter)
    BaseSelectMulti.users.select(:value="filters.observers" @input="changeFilters($event, 'observers')" :options="userOptions.watchers" label="Наблюдатель")
  ._buttons
    ._icon(v-for="b in buttons" :key="b.name" @click="b.handler" :class="{ active: b.active }")
      BaseTooltipDropdown._tooltip(:text="b.title" dark noWrap)
      Icon(colored pointer :name="b.name")
  //._extra-filters(v-if="extraFiltersAreVisible")
</template>

<style scoped lang="scss">
.task-filters-container {
  display: grid;
  grid-template-columns: 1fr max-content;
  align-content: center;
  gap: 16px;

  &__main-filters, &__extra-filters {
    display: flex;
    gap: 16px;
  }

  &__buttons {
    border-radius: 8px;
    height: 38px;
    background: var(--color-super-light);
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 0 10px;
  }

  &__icon {
    position: relative;

    &:nth-child(1):not(.active) svg {
      transform: rotate(180deg);
    }

    &:last-child svg {
      width: 17px;
      height: 17px;
    }

    svg {
      color: #788CA1;
      display: block;
    }

    &.active svg, &:hover svg {
      color: rgba(51, 161, 251, 1);
    }
  }

  &__tooltip {
    display: none;
  }

  &__icon:hover &__tooltip {
    display: block;
    opacity: 1;
    visibility: visible;
  }

  @media (max-width: 1385px) {
    grid-template-columns: 1fr;

    &__buttons {
      justify-self: start;
      grid-row: 3;
    }

    &__main-filters, &__extra-filters {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media (max-width: 768px) {
    &__main-filters, &__extra-filters {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 576px) {
    &__main-filters, &__extra-filters {
      display: grid;
      grid-template-columns: 1fr;
    }
  }
}
</style>
